import React from "react";
import { FUEL_TYPE } from "../../constants/tariffInfo";
import { useTariff } from "../../context/TariffContext";
import EN from "../../locales/en";
import ElectricityIcon from "../ElectricityIcon";
import GasIcon from "../GasIcon";

const AnnualUsageCard = ({
  setShowHowUsageCalculatedModal,
  showEditUsageForm,
}) => {
  const {
    deleteUserDefinedTariffInfoKey,
    combinedTariffInfo,
    userDefinedTariffInfo,
  } = useTariff();

  const elecSupplierName = combinedTariffInfo?.existingSupplierNameElec;
  const gasSupplierName = combinedTariffInfo?.existingSupplierNameGas;
  const elecTariffName = combinedTariffInfo?.existingTariffNameElec;
  const gasTariffName = combinedTariffInfo?.existingTariffNameGas;
  const fuelType = combinedTariffInfo?.fuelType;
  const isELecGasSameSupplierAndTariff =
    fuelType === FUEL_TYPE.ELECGAS &&
    gasTariffName &&
    gasSupplierName &&
    gasTariffName === elecTariffName &&
    gasSupplierName === elecSupplierName;

  return (
    <div className="border-2 border-[#afb6b9] rounded-[4px] p-4">
      <div className="flex justify-between items-start">
        <h3 className="text-md font-bold leading-[1.5]">
          {EN.energy_usage.annual_details_text}
        </h3>
        <button
          className="text-primary underline inline-block text-center"
          onClick={showEditUsageForm}
        >
          {EN.energy_usage.change_button_text}
        </button>
      </div>

      <div className="border-t border-[#afb6b9] mt-4 py-4">
        {(isELecGasSameSupplierAndTariff ||
          fuelType === FUEL_TYPE.ELEC ||
          fuelType === FUEL_TYPE.GAS) && (
          <div className="space-y-4">
            <div className="space-y-2">
              <p>
                Supplier:{" "}
                <strong>
                  {fuelType === FUEL_TYPE.GAS
                    ? gasSupplierName
                    : elecSupplierName}
                </strong>
              </p>

              <p>
                Tariff:{" "}
                <strong>
                  {fuelType === FUEL_TYPE.GAS ? gasTariffName : elecTariffName}
                </strong>
              </p>
            </div>

            {(fuelType === FUEL_TYPE.ELEC ||
              fuelType === FUEL_TYPE.ELECGAS) && (
              <div className="flex justify-between">
                <div className="flex-1 flex items-center">
                  <ElectricityIcon />
                  <p>
                    Electricity:{" "}
                    <strong>
                      {Math.round(combinedTariffInfo?.existingkWhsElec)}
                      kWh
                    </strong>
                  </p>
                </div>
                {userDefinedTariffInfo?.existingkWhsElec && (
                  <button
                    className="flex-shrink-0 ml-2 text-primary underline inline-block text-center"
                    onClick={() =>
                      deleteUserDefinedTariffInfoKey("existingkWhsElec")
                    }
                  >
                    Reset
                  </button>
                )}
              </div>
            )}

            {(fuelType === FUEL_TYPE.GAS || fuelType === FUEL_TYPE.ELECGAS) && (
              <div className="flex justify-between">
                <div className="flex-1 flex items-center">
                  <GasIcon />
                  <p>
                    Gas:{" "}
                    <strong>
                      {Math.round(combinedTariffInfo?.existingkWhsGas)}
                      kWh
                    </strong>
                  </p>
                </div>
                {userDefinedTariffInfo?.existingkWhsGas && (
                  <button
                    className="flex-shrink-0 ml-2 text-primary underline inline-block text-center"
                    onClick={() =>
                      deleteUserDefinedTariffInfoKey("existingkWhsGas")
                    }
                  >
                    Reset
                  </button>
                )}
              </div>
            )}
          </div>
        )}
        {fuelType === FUEL_TYPE.ELECGAS && !isELecGasSameSupplierAndTariff && (
          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-2">
              <ElectricityIcon />

              <p>
                Electricity Supplier: <br />
                <strong>{elecSupplierName}</strong>
              </p>

              <p>
                Electricity Tariff: <br />
                <strong>{elecTariffName}</strong>
              </p>

              <div>
                <p>
                  Electricity Usage:
                  <br />
                  <strong>
                    {Math.round(combinedTariffInfo?.existingkWhsElec)}
                    kWh
                  </strong>
                </p>
              </div>

              {userDefinedTariffInfo?.existingkWhsElec && (
                <button
                  className="flex-shrink-0 text-primary underline inline-block text-center"
                  onClick={() =>
                    deleteUserDefinedTariffInfoKey("existingkWhsElec")
                  }
                >
                  Reset
                </button>
              )}
            </div>
            <div className="space-y-2">
              <GasIcon />

              <p>
                Gas Supplier: <br />
                <strong>{gasSupplierName}</strong>
              </p>

              <p>
                Gas Tariff: <br />
                <strong>{gasTariffName}</strong>
              </p>

              <div>
                <p>
                  Gas Usage:
                  <br />
                  <strong>
                    {Math.round(combinedTariffInfo?.existingkWhsGas)}
                    kWh
                  </strong>
                </p>
              </div>

              {userDefinedTariffInfo?.existingkWhsGas && (
                <button
                  className="flex-shrink-0 text-primary underline inline-block text-center"
                  onClick={() =>
                    deleteUserDefinedTariffInfoKey("existingkWhsGas")
                  }
                >
                  Reset
                </button>
              )}
            </div>
          </div>
        )}
      </div>

      <button
        className="text-primary underline inline-block text-center"
        onClick={() => setShowHowUsageCalculatedModal(true)}
      >
        {EN.energy_usage.how_was_usage_calculated_text}
      </button>
    </div>
  );
};

export default AnnualUsageCard;
